import React from "react";
import styled from "styled-components";

interface TextareaProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  hasError?: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: 100%;
`;

const Label = styled.label`
  font-size: 12px;
  color: #5e6366;
  margin-bottom: 5px;
  font-family: "Mont", sans-serif;
`;

const StyledTextarea = styled.textarea<{ hasError?: boolean }>`
  padding: 10px;
  height: 150px;
  font-size: 16px;
  border: 1px solid ${(props) => (props.hasError ? "#ff0000" : "#cfd3d4")};
  color: ${(props) => (props.hasError ? "#ff0000" : "#5e6366")};
  border-radius: 8px;
  font-family: "Mont", sans-serif;
  text-align: left;
  &:focus {
    border-color: ${(props) => (props.hasError ? "#ff0000" : "#5570f1")};
  }
`;

const Textarea: React.FC<TextareaProps> = ({
  label,
  value,
  onChange,
  hasError,
}) => {
  return (
    <Container>
      <Label>{label}</Label>
      <StyledTextarea value={value} onChange={onChange} hasError={hasError} />
    </Container>
  );
};

export default Textarea;

